import merge from "lodash.merge";
import { CompactComponentsConfigs } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/compact/config/components/components";
import { DefaultComponentsConfigs } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/config/components/components";
import { defaultTheme } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/default/default-theme";
import { FlatCompactComponentsConfigs } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat-compact/config/components/components";
import { FlatComponentsConfigs } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/components/components";
import { applicationFrameConfig } from "./application-frame";
import { applicationHeaderConfig } from "./application-header";
import { applicationTitle } from "./application-title";
import { badgeConfig } from "./badge";
import { baseInputConfig } from "./base-input";
import { buttonConfig } from "./button";
import { checkboxConfig } from "./checkbox";
import { contentBoxConfig } from "./content-box";
import { editorConfig } from "./editor";
import { formConfig } from "./form";
import { headerTriggerConfig } from "./header-trigger";
import { loginLayoutConfig } from "./login-layout";
import { menuConfig } from "./menu";
import { messageBoxConfig } from "./message-box";
import { modalOverlayConfig } from "./modal-overlay";
import { progressIndicatorConfig } from "./progress-indicator";
import { radioConfig } from "./radio";
import { statusConfig } from "./status";
import { tabPanelConfig } from "./tab-panel";
import { tableConfig } from "./table";
import { textAreaConfig } from "./text-area";
import { treeTableConfig } from "./tree-table";
import { typographyConfig } from "./typography";
import { wizardConfig } from "./wizard";
export function applyModulFComponentsConfigs(params) {
    const propsWithComponents = { ...params, components: defaultTheme.components };
    return {
        ...params,
        components: merge({}, DefaultComponentsConfigs(params), FlatComponentsConfigs(propsWithComponents), params.compact
            ? merge({}, CompactComponentsConfigs(propsWithComponents), FlatCompactComponentsConfigs(propsWithComponents))
            : {}, {
            applicationFrame: applicationFrameConfig(params),
            applicationHeader: applicationHeaderConfig(params),
            applicationTitle: applicationTitle(params),
            badge: badgeConfig(params),
            baseInput: baseInputConfig(params),
            button: buttonConfig(),
            checkbox: checkboxConfig(params),
            contentBox: contentBoxConfig(params),
            editor: editorConfig(params),
            form: formConfig(),
            headerTrigger: headerTriggerConfig(params),
            loginLayout: loginLayoutConfig(params),
            menu: menuConfig(),
            messageBox: messageBoxConfig(),
            modalOverlay: modalOverlayConfig(params),
            progressIndicator: progressIndicatorConfig(params),
            radio: radioConfig(params),
            status: statusConfig(params),
            table: tableConfig(params),
            tabPanel: tabPanelConfig(params),
            textArea: textAreaConfig(),
            treeTable: treeTableConfig(params),
            typography: typographyConfig(params),
            wizard: wizardConfig(params)
        })
    };
}
